
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#312F2F","fill-rule":"evenodd","d":"M3.521 13.997l6.477-7.003L3.521-.011h-3l6.477 7.005-6.477 7.003h3z"}})])
          )
        }
      }
    